import { useEffect } from 'react';
import { useAuth } from './useAuth';
import { useDispatch } from 'react-redux';
import axios, { AxiosError } from 'axios';

import {
  changeOther,
  endLoading,
  loadElements,
  openModal,
  store,
} from '../constants/initialStore';
import { formats } from '../constants/formats';
import { redirect, useParams, useSearchParams } from 'react-router-dom';
import { otherFormats } from '../constants/otherFormats';
import { createOther, createOtherFromSKU, getOngoingOther } from '../api/other';
import { ConvertMMToPixel } from '../utils/convertCMToPixel';
import { defaultElementsOnPage } from '../constants/defaultElementOnPage';




export const createOtherFn = async () => {
  const searchParams = new URLSearchParams(window.location.search);
  const formatAsked = searchParams.get('format') || Object.keys(formats)[0];
  const accessory = searchParams.get('accessory') ?? '0';
  const paperId = searchParams.get('paperId') ?? '0';
  const languageAsked = searchParams.get('lng') || 'fr';
  const fromCart = searchParams.get('fromCart') || false;
  const format = otherFormats[formatAsked];
  const { width: mmWidth, height: mmHeight } = format;
  const width = ConvertMMToPixel(mmWidth);
  const height = ConvertMMToPixel(mmHeight);
  const payload = {
    format: formatAsked,
    backgroundColor: '#ffffff',
    backgroundTheme: undefined,
    accessory: accessory,
    paperId: parseInt(paperId),
    elements:
      format.defaultElementsOnPage &&
      defaultElementsOnPage[format.defaultElementsOnPage]
        ? defaultElementsOnPage[format.defaultElementsOnPage](width, height)
        : defaultElementsOnPage['oneFullSizePhoto'](width, height),
  };

  const newCreation = await createOther(payload, languageAsked);
  store.dispatch(
    changeOther({
      ...newCreation,
    }),
  );
  window.location.replace(
    window.location.origin +
      `/autre/${newCreation.id}?lng=${languageAsked}${
        fromCart ? '&fromCart=true' : ''
      }`,
  );
  return newCreation;
};

export const createOtherWithSKU = async () => {
  const searchParams = new URLSearchParams(window.location.search);
  const SKUAsked = searchParams.get('sku') ?? '';
  const paperId = searchParams.get('paperId') ?? '0';
  const accessory = searchParams.get('accessory') ?? null;
  const languageAsked = searchParams.get('lng') || 'fr';
  const fromCart = searchParams.get('fromCart') || false;

  try {
    const newOther = await createOtherFromSKU(SKUAsked, {
      paperId: parseInt(paperId),
      accessory: accessory ? accessory : undefined
    });

    if (!newOther || !newOther.id) {
      throw new Error('Erreur lors de la création de l’objet Other');
    }

    store.dispatch(changeOther({ ...newOther }));

    window.location.replace(
      window.location.origin +
        `/autre/${newOther.id}?lng=${languageAsked}${
          fromCart ? '&fromCart=true' : ''
        }`,
    );
  } 
  catch (error: unknown) {
    store.dispatch(endLoading());
    if (axios.isAxiosError(error)) {
      if (error.response?.status === 404) {
        console.error("Erreur 404 : SKU non trouvé", error);
        alert("Le modèle demandé n'existe pas ou n'est plus disponible.");
      } else {
        console.error("Erreur lors de la création :", error);
      }
    } else {
      console.error("Erreur inconnue :", error);
    }
  }
};


export const fetchDispatchOther = async (id?: string) => {
  const searchParams = new URLSearchParams(window.location.search);
  const languageAsked = searchParams.get('lng') || 'fr';
  const fromCart = searchParams.get('fromCart') || false;
  const savedOther = await getOngoingOther(id);
  if (!id)
    return window.location.replace(
      window.location.origin +
        `/autre/${savedOther.id}?lng=${languageAsked}${
          fromCart ? '&fromCart=true' : ''
        }`,
    );
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  if (!savedOther) return redirect('/404');
  const { ownerID: _1, ...rest } = savedOther;
  const creation = rest;
  store.dispatch(changeOther(creation));
  store.dispatch(
    loadElements(
      creation.elements.map((element) => ({
        ...element,
        style: element.style
          ? JSON.parse(element.style as unknown as string)
          : undefined,
      })),
    ),
  );
  store.dispatch(endLoading());
  return creation;
};

export const useFetchOrCreateOther = () => {
  const { userInfo, isReady, useNewAccessToken } = useAuth();
  const dispatch = useDispatch();
  const { id } = useParams();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    if (isReady) {
      const newToken = searchParams.get('token');
      if (newToken) {
        const res = useNewAccessToken(newToken);
        if (res) {
          const urlActuelle = window.location.href;
          const urlSansToken = urlActuelle.replace(/token=[^&]*(&?)/, '');
          window.location.replace(urlSansToken);
        }
      }
    }
    if (
      window.location.pathname.includes('calendrier') ||
      window.location.pathname.includes('album') ||
      window.location.pathname.includes('carte') ||
      window.location.pathname.includes('admin') // Route type is inferred later
    ) {
      return;
    }


        if (userInfo === null) {
          return;
        }
    
        if (id && id !== 'nouvelle' && id !== 'nouveau') {
          fetchDispatchOther(id);
          return;
        }
        if (searchParams.get('sku')) {
          createOtherWithSKU();
          return;
        } else if (searchParams.get('format')) {
          createOtherFn();
        }

    // it is here to prevent multiple creation, but the useEffect should be transformed in the future so it is not triggered so often
    // if (userInfo === null) {
    //   return;
    // }

    // if (!id) {
    //   fetchDispatchOther(); // Last creation
    //   return;
    // }
    // if (id && id !== 'nouveau') {
    //   fetchDispatchOther(id);
    //   return;
    // }
    // createOtherFn();
  }, [userInfo, isReady, searchParams]);
};
